<template>
  <v-content class="ticket_complete">
    <div v-if="completed" class="secure-result">
      <div v-if="is_succeeded && type === 'lottery'" class="success-message">
        <h1 class="message-title">エントリーが完了しました</h1>
      </div>
      <div v-else-if="is_succeeded" class="success-message">
        <h1 class="message-title">支払いが完了しました</h1>
      </div>
      <!-- 失敗時のメッセージ -->
      <div v-else class="error-message">
        <h1 v-if="type === 'lottery'" class="message-title">エントリーに失敗しました</h1>
        <h1 v-else class="message-title">支払いに失敗しました</h1>
        <p class="error-details">{{ message }}</p>
      </div>
      <v-btn v-if="is_succeeded" rounded class="ok-button maincolor-bg" @click="handleOk">
        OK
      </v-btn>
      <v-btn v-else rounded class="ng-button maincolor-bg" @click="handleNg">
        詳細へ戻る
      </v-btn>
    </div>
  </v-content>
</template>
  
<script>
  const CONFIRM_RESULT = {
    SUCCEEDED: 1,
    FAILED: 0,
  };

  export default {
    data() {
      return {
        completed: false,
        type: null,
        ticket_id: null,
        shop_id: null,
        customer_shop_id: null,
        payment_intent_id: null,
        setup_intent_id: null,
        message: '',
        is_succeeded: false,
      };
    },

    async created() {
      try {
        this.init = this.storageGet('*');
        this.getQueryParams();
        if (this.payment_intent_id || this.setup_intent_id) {
          let response;
          if (this.type === 'lottery') {
            response = await this.apiCall('/stripe/digitalticket/post-confirm-setup', { setup_intent_id: this.setup_intent_id, payment_shop_id: this.customer_shop_id }, 'post');
            if (!response) {
              this.callDialog('決済処理エラー', 'デジタルチケット支払いカード確定後処理でエラーとなりました。', 3);
              return false;
            }
            this.is_succeeded = response.is_setup_succeeded === CONFIRM_RESULT.SUCCEEDED ? true : false;
            this.message = response.result_message || '';
          } else {
            response = await this.apiCall('/stripe/digitalticket/post-confirm-payment', { payment_intent_id: this.payment_intent_id, payment_shop_id: this.customer_shop_id }, 'post');
            if (!response) {
              this.callDialog('決済処理エラー', 'デジタルチケット決済後処理でエラーとなりました。', 3);
              return false;
            }
            this.is_succeeded = response.is_payment_succeeded == CONFIRM_RESULT.SUCCEEDED ? true : false;
            this.message = response.result_message || '';
          }
        } else {
          // stripe_id がない場合はエラー
          this.is_succeeded = false;
          this.message = 'stripe_id が見つかりません。';
        }
      } catch (error) {
        console.error('error : ', error);
        this.is_succeeded = false;
        this.message = 'システムエラーが発生しました。';
        this.callDialog('通信エラー', 'ネットワークの状態が不安定です。再度お試しください', 3);
      } finally {
        this.completed = true;
      }
    },

    methods: {
      getQueryParams() {
        this.type = this.decodeParam(this.$route.query.type || 'normal');
        this.ticket_id = this.decodeParam(this.$route.query.ticket_id || '');
        this.shop_id = this.decodeParam(this.$route.query.shop_id || '');
        this.customer_shop_id = this.decodeParam(this.$route.query.customer_shop_id || '');
        this.payment_intent_id = this.decodeParam(
          this.$route.query.payment_intent || ''
        );
        this.setup_intent_id = this.decodeParam(
          this.$route.query.setup_intent || ''
        );
      },

      decodeParam(param) {
        try {
          return decodeURIComponent(param);
        } catch (e) {
          console.log('Invaid URL Parameter:', param, e)
          return param;
        }
      },

      handleOk() {
        if (this.type === 'lottery') {
          // 販売中チケット一覧画面に遷移
          this.routerBindTo({name: 'digital_list', query: {shop_id: this.shop_id}});

        } else {
          // 購入済みチケット一覧画面に遷移
          this.routerBindTo({name: 'digital_list', query: {is_bought: 1, page: 1}});
        }
      },
      handleNg() {
        // デジタルチケット詳細画面に遷移
        this.routerBindTo({ name: 'digital_detail', query: { ticket_id: this.ticket_id }});
      },
    },
  };
</script>
  
<style scoped>
  .secure-result {
   height: 100vh;
   display: flex;
   flex-direction: column;
   justify-content: center;
   align-items: center;
   background-color: #f9f9f9; /* 背景色 */
  }
  
  .success-message svg,
  .error-message svg {
   margin-bottom: 20px;
  }
  
  .message-title {
   font-size: 18px;
   font-weight: bold;
   margin-bottom: 20px;
   text-align: center;
  }
  
  .error-details {
   font-size: 14px;
   color: #f44336;
   margin: 5px 0;
   text-align: center;
  }
  
  .ok-button {
   width: 100px;
   color: #fff;
   margin-top: 20px;
  }

  .ng-button {
   width: 100px;
   color: #fff;
   margin-top: 20px;
  }
</style>
